<template>
    <b-row>
        <div class="col-sm-12 mt-3">
            <h3>
                Reporte de ventas por producto
            </h3>
        </div>
        <div class="col-sm-3 mt-3">
            <label for="" class="form-label">Sucursal</label>
            <select class="form-control form-control-sm" v-model="sucursal_"
                @change="limpiar_carrito_al_cambio_de_sucursal">
                <option value="">Seleccionar</option>
                <option value="0">Consolidado</option>
                <option v-for="(item, index) in SUCURSALES_SIN_BODEGA_CENTRAL" :key="index" :value="item.codigo">{{
                    item.nombre }}
                </option>
            </select>
        </div>
        <div class="col-sm-3 mt-3">
            <label for="" class="form-label">Código</label>
            <input type="text" list="productos_" :disabled="FILTRAR_PRODUCTOS_POR_SUCURSAL.length === 0"
                autocomplete="off" class="form-control form-control-sm" v-model="codigo_producto"
                @keyup="aplicar_producto_seleccionado">
            <datalist id="productos_">
                <option v-for="(item, index) in FILTRAR_PRODUCTOS_POR_SUCURSAL" :key="index" :value="item.codigo">{{
                    item.nombre
                    }}</option>
            </datalist>
        </div>
        <div class="col-sm-2 mt-3">
            <label for="" class="form-label">Fecha Inicial</label>
            <input type="date" class="form-control form-control-sm" v-model="fecha_inicial">
        </div>
        <div class="col-sm-2 mt-3">
            <label for="" class="form-label">Fecha Final</label>
            <input type="date" class="form-control form-control-sm" v-model="fecha_final">
        </div>
        <div class="col-sm-2 mt-5">
            <button type="button" class="btn btn-sm btn-outline-dark btn-block"
                @click="buscar_registros_por_producto">Buscar</button>
        </div>
        <div class="col-sm-12 mt-3">
            <div class="contenedor_texto_articulo">
                {{ nombre_articulo }}
            </div>
        </div>
        <div class="col-sm-12 mt-3">
            <div class="marco_reporte_producto">

                <table class="table table-sm table-striped table-bordered" style="font-size: 12px;">
                    <thead>
                        <tr>
                            <th style="width: 40%;">
                                DTE
                            </th>
                            <th style="width: 15%;text-align: center;">
                                Fecha
                            </th>
                            <th style="width: 15%; text-align: center;">
                                Cantidad
                            </th>
                            <th style="width:15%; text-align: center;">
                                Precio
                            </th>
                            <th style="width: 15%; text-align: center;">
                                Subtotal
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in carrito" :key="index">
                            <td>
                                {{ item.dte }}
                            </td>
                            <td style="text-align: center;">
                                {{ item.fecha_movimiento }}
                            </td>
                            <td style="text-align: center;">
                                {{ Math.abs(item.cantidad) }}
                            </td>
                            <td style="text-align: center;">
                                Q{{ item.precio.toLocaleString(undefined, {
                                    minimumFractionDigits: 2, maximumFractionDigits: 2
                                }) }}
                            </td>
                            <td style="text-align: center;">
                                {{ (item.precio * Math.abs(item.cantidad)).toLocaleString(undefined, {
                                    minimumFractionDigits: 2, maximumFractionDigits: 2
                                }) }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="col-sm-12 mt-3">
            <div class="contenedor_gran_total">
                Total: Q{{ gran_total.toLocaleString(undefined, {
                    minimumFractionDigits: 2, maximumFractionDigits: 2
                }) }}

            </div>
        </div>
    </b-row>
</template>

<script>
    import { minix } from '@/components/functions/alertas';
    import moment from 'moment';
    import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';

    export default {
        name: 'ReporteProducto',
        computed: {
            ...mapState(['id_empresa_seleccionada']),
            ...mapGetters(['SUCURSALES_SIN_BODEGA_CENTRAL', 'FILTRAR_PRODUCTOS_POR_SUCURSAL'])
        },
        data() {
            return {
                nombre_articulo: '-',
                codigo_producto: '',
                fecha_inicial: moment(Date.now()).format('YYYY-MM-DD'),
                fecha_final: moment(Date.now()).format('YYYY-MM-DD'),
                gran_total: 0,
                sucursal_: '',
                carrito: []
            }
        },
        methods: {
            aplicar_producto_seleccionado() {
                for (let i = 0; i < this.FILTRAR_PRODUCTOS_POR_SUCURSAL.length; i++) {
                    if (this.FILTRAR_PRODUCTOS_POR_SUCURSAL[i].codigo == this.codigo_producto) {
                        this.nombre_articulo = this.FILTRAR_PRODUCTOS_POR_SUCURSAL[i].nombre
                    }
                }
            },
            async buscar_registros_por_producto() {
                if (this.sucursal_ == '' || this.codigo_producto == '' || this.fecha_inicial == '' || this.fecha_final == '') {
                    minix({ icon: 'info', mensaje: 'Todos los campos son obligatorios', tiempo: 3000 })

                } else {
                    let f = {
                        api: `movimientos-detalles/c/movimientos_de_ventas_por_producto?fecha_inicial=${this.fecha_inicial}&fecha_final=${this.fecha_final}&codigo=${this.codigo_producto}&sucursal=${this.sucursal_}&empresa=${this.id_empresa_seleccionada}`
                    }

                    let r = await this.obtener_data(f)
                    if (r.length == 0) {
                        minix({ icon: 'info', mensaje: 'No se encontraron registros', tiempo: 3000 })

                    } else {
                        this.carrito = r
                        this.suma_subtotales()
                    }

                }
            },
            suma_subtotales() {
                let contador = 0

                for (let i = 0; i < this.carrito.length; i++) {
                    let e = this.carrito[i];
                    contador += e.precio * (e.cantidad * -1)
                }

                this.gran_total = contador
            },
            setear_sucursal_origen() {
                this.set_filtro_productos_sucursales_traslados(parseInt(this.sucursal_))
            },
            limpiar_carrito_al_cambio_de_sucursal() {
                this.carrito = []
                this.setear_sucursal_origen()
                this.suma_subtotales()
            },
            ...mapActions(['obtener_data']),
            ...mapMutations(['set_filtro_productos_sucursales_traslados'])
        },
    }
</script>

<style>
    .marco_reporte_producto {
        width: 100%;
        height: calc(100vh - 450px);
        border: 1px solid #e9e9e9;
        border-radius: 4px;
        overflow: auto;
    }

    .contenedor_gran_total {
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: bold;
        font-size: 30px;
    }
</style>